import React, { Component } from 'react'
import buttonConfig from './../../configs/social-config'
import {
  generateShareIcon
} from 'react-share';

class SocialMediaButtons extends Component {
  render () {
    const buttons = buttonConfig.map(({SocialButton, icon, extraProps = {}}, i) => {
    const ShareIcon = generateShareIcon(icon);
    const { pathname } = this.props

      return (
        <SocialButton {...extraProps} key={`${icon}-${i}`} url={pathname}>
          <ShareIcon size={32} round={true} />
        </SocialButton>
      );
    })

    return (
      <div className="social-media">
        {buttons}
      </div>
    )
  }
}

export default SocialMediaButtons



// WEBPACK FOOTER //
// ./src/components/Outreach/SocialMedia.js